// import { prefixClass } from '../styles-interface';

export function setupClearPinButton() {
  // const className = prefixClass('clear-pin-button');
  const className = 'lk-clear-pin-button lk-button';
  return { className };
}
